import { render, staticRenderFns } from "./Buyers.vue?vue&type=template&id=692fad74&scoped=true"
import script from "./Buyers.vue?vue&type=script&lang=js"
export * from "./Buyers.vue?vue&type=script&lang=js"
import style0 from "./Buyers.vue?vue&type=style&index=0&id=692fad74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692fad74",
  null
  
)

export default component.exports